import script from "./AtomTableModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./AtomTableModal.vue?vue&type=script&lang=ts&setup=true"

import "./AtomTableModal.vue?vue&type=style&index=0&id=521e8cb7&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-521e8cb7"]])

export default __exports__